export default __webpack_public_path__ + "static/media/download.77e4a94b.svg";